// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../utils/dispatchToProps';
import type { Match } from 'react-router-dom';
import { loansEditLoan, loansGetLoans, loansSetStateForEdit } from '../../actions/loans';
import type { ErrorsState, LoansAddState, LoansState, State } from '../../types/state';
import { returnSubsetByIdOrParent } from '../../utils/stateHelpers';
import { ConnectedSectionWrapper } from '../shared/section-wrapper';
import { ConnectedLoanForm } from './form';

type Props = {
	loansGetLoans: typeof loansGetLoans;
	loansSetStateForEdit: typeof loansSetStateForEdit;
	loansEditLoan: typeof loansEditLoan;
	addState: LoansAddState;
	adding: boolean;
	errors: ErrorsState;
	match: Match;
	loans: LoansState;
};

class EditLoan extends Component<Props> {

	componentWillMount() {
		this.initialLoad();
	}

	componentDidUpdate() {
		this.initialLoad();
	}

	initialLoad = () => {
		this.props.loansGetLoans();

		this.setEditState();
	};

	setEditState = () => {
		if ( this.props.loans.ids.indexOf( this.getId() ) === -1 ) {
			return false;
		}

		if ( this.props.loans.editing === this.getId() ) {
			return false;
		}

		let loanState = returnSubsetByIdOrParent( this.getId(), this.props.loans.objects );
		loanState = loanState[0];

		this.props.loansSetStateForEdit( this.getId(), loanState );
	};

	getId = () : number => {
		let { id } = this.props.match.params;

		id = 'string' === typeof id ? id : '';

		// get rid of bad characters
		id = id.replace( '\ufeff', '' );

		return parseInt( id, 10 );
	};

	save = () => {
		this.props.loansEditLoan( this.getId() );
	};

	render() {
		return (
			<ConnectedSectionWrapper
				title="Edit Loan"
				render={() => (
					<ConnectedLoanForm
						addState={this.props.addState}
						adding={this.props.adding}
						errors={this.props.errors}
						saveCallback={this.save}
					/>
				)}
			/>
		)
	}

}

const mapStateToProps = ( state: State ) => ({
	addState: state.loans.add,
	adding: state.loans.adding,
	errors: state.loans.errors,
	loans: state.loans,
});

export const ConnectedEditLoan = connect( mapStateToProps, mapDispatchToProps )( EditLoan );
